export default () => (
  navigator.language.split('-')[0]
);
